import { Box } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import { useFullScreenHandle } from "react-full-screen";
import { useDispatch, useSelector } from "react-redux";
import InteractiveAction from ".";
import { getInteractiveAction } from "../../../store/actions/interactive";

const Interactive = ({ currentTime, videoRef, data, pause }) => {
  // const [seconds, setSeconds] = useState(0);

  const dispatch = useDispatch();

  const fetchData = async ({ id, demo }) => {
    await getInteractiveAction(id, demo)(dispatch);
  };
  
  useEffect(() => {
    console.log("list", currentTime && data?.videoPause);
    if (currentTime && data?.videoPause) {
      pause();
    }
  }, [currentTime, data]);

  useEffect(() => {
    fetchData({ id: data?.entityId });
  }, []);

  const [selectedAction, setSelectedAction] = useState();
  const [videoWidth, setVideoWidth] = useState();
  const [videoHeight, setVideoHeight] = useState();

  const interactive = useSelector((s) => s.interactive.data);

  const handle = useFullScreenHandle();

  const soundRef = useRef();

  const [currentSegmentIndex, setCurrentSegmentIndex] = useState(1);
  const [currentSegment, setCurrentSegment] = useState();

  const [updateState, setUpdateState] = useState(false);

  const refreshState = () => {
    setUpdateState(!updateState);
  };
  const handleSegmentEnd = (instantAction) => {
    if (instantAction != null) {
      setCurrentSegmentIndex(instantAction?.value);
    } else if (selectedAction != null) {
      setCurrentSegmentIndex(selectedAction?.value);
    } else if (!currentSegment?.isLoop) {
      setCurrentSegmentIndex(currentSegment?.index + 1);
    }

    disableAllActions();
    setSelectedAction(null);
  };
  const handleActionClick = async (action) => {
    if (selectedAction == null) {
      setSelectedAction(action);

      playActionSound();
      // setPlaying(true);

      if (currentSegment?.isLoop) {
        handleSegmentEnd(action);
      }
    }
  };

  const disableAllActions = () => {
    if (currentSegment?.actions) {
      for (let action of currentSegment?.actions) {
        action = { ...action, show: false };
        refreshState();
      }
    }
  };

  const playActionSound = () => {
    const audioPlayer = soundRef.current;
    audioPlayer?.play();
  };

  useEffect(() => {
    updateVideoSize();
    window.addEventListener("resize", updateVideoSize);

    return () => {
      window.removeEventListener("resize", updateVideoSize);
    };
  }, [handle?.active]);

  useEffect(() => {
    let s =
      Array.isArray(interactive) &&
      interactive?.find((e) => e?.index == currentSegmentIndex);
    setCurrentSegment(s);
  }, [interactive?.length, currentSegmentIndex, interactive]);

  const updateVideoSize = () => {
    setVideoWidth(
      handle.active
        ? window?.screen?.width
        : videoRef?.current?.getBoundingClientRect().width
    );
    setVideoHeight(
      handle.active
        ? window?.screen?.height
        : videoRef?.current?.getBoundingClientRect().height
    );
  };

  // const [playing, setPlaying] = useState(false);
  // const [muted, setMuted] = useState(false);

  // const handleTimeUpdate = (progress) => {
  //   handleActionsDisplay();
  //   setSeconds(progress.playedSeconds);
  // };

  // const handleActionsDisplay = () => {
  //   let currentTime = videoRef.current?.getCurrentTime();

  //   if (currentSegment?.actions) {
  //     for (const [index, action] of currentSegment?.actions?.entries()) {
  //       let actionTime = action?.delay;

  //       if (!action.show && currentTime >= actionTime) {
  //         let newAction = { ...action, show: true };
  //         let newSegment = { ...currentSegment };
  //         newSegment.actions[index] = newAction;

  //         setCurrentSegment(newSegment);
  //       }
  //     }
  //   }
  // };

  return (
    <>
      <Box
        sx={{
          position: "absolute",
          bottom: 40,
          left: 0,
          right: 0,
          display: currentTime ? "flex" : "none",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          flexWrap: "wrap",
          width: 1,
          zIndex: 11,
        }}
      >
        {currentSegment?.actions?.map((action, index) => (
          <InteractiveAction
            key={index}
            action={action}
            disabled={selectedAction !== null && action !== selectedAction}
            onClick={() => handleActionClick(action)}
            isSelected={action === selectedAction}
            animate={!currentSegment?.isLoop}
            videoWidth={videoWidth}
            videoHeight={videoHeight}
            fullScreen={handle}
            handleSegmentEnd={handleSegmentEnd}
          />
        ))}
      </Box>
    </>
  );
};

export default Interactive;
